import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DeviceStorageStatus.css';
import Modal from '../Modal/Modal';
import EditStorageStatus from './EditStorageStatus';
import CustomButton from '../CustomElements/CustomButton';
import TransferDeviceToRepair from './TransferDeviceToRepair';
import TransferDeviceToUsage from './TransferDeviceToUsage';
import TransferDevice from './TransferDevice';
import DeviceWriteOff from './DeviceWriteOff';
import TransferUippsToUsage from './TransferUippsToUsage';
import TableMap from './TableMap';
// Кастомные хуки
import useModalWithStatus from '../../customHook/useModalWithStatus';
import useDeviceStatus from '../../customHook/useDeviceStatus';
import { useRole } from '../../customHook/useRole';
// Действия Redux
import { initStatusesFromServer } from '../../redux/actions/statuses.action';
import { STATUS } from '../../constants/status';

// компонент для отображения таблицы статусов хранения устройства
// и обработки действий с ними.

function DeviceStorageStatus({ currentDevice, uippsType, setActiveButton, activeButton, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  //проверяем роли пользователя
  const isMaster = useRole('master');

  //получаем массив статусов Хранение из стора
  const { storageStatuses } = useSelector((state) => state?.statuses);
  const [statusId, setStatusId] = useState('');

  // Получаем id статуса текущего устройства
  const deviceStatusId = currentDevice?.statusId;
  // Кнопка отключена, если статус не "Хранение" (STORAGE = 9)
  const disabledBtn = deviceStatusId !== STATUS.STORAGE;

  // хук для получения текущего статуса по id
  const currentStatus = useDeviceStatus(storageStatuses, statusId);

  // Хук для управления модальным окном статусов
  const { isOpen, activeModal, closeModal, handleButtonClick } = useModalWithStatus(
    storageStatuses,
    currentDevice,
    setStatusId
  );

  // компоненты для отображения
  const contentData = {
    [t?.statusTransferToAnotherStorage || 'Переместить на другой склад']: (
      <TransferDevice currentDevice={currentDevice} closeModal={closeModal} isEdit={false} t={t} />
    ),
    [t?.statusIssueOperation || 'Выдать в эксплуатацию']: uippsType ? (
      <TransferUippsToUsage currentDevice={currentDevice} closeModal={closeModal} t={t} />
    ) : (
      <TransferDeviceToUsage currentDevice={currentDevice} closeModal={closeModal} t={t} />
    ),
    [t?.statusSendForRepair || 'Направить в ремонт']: (
      <TransferDeviceToRepair currentDevice={currentDevice} closeModal={closeModal} t={t} />
    ),
    [t?.statusWriteOff || 'Списать']: (
      <DeviceWriteOff currentDevice={currentDevice} closeModal={closeModal} isOpen={isOpen} t={t} />
    ),
    edit:
      currentStatus?.fromStatusId === 9 ? (
        <TransferDevice
          currentDevice={currentDevice}
          currentStatus={currentStatus}
          closeModal={closeModal}
          isEdit={true}
          t={t}
        />
      ) : (
        <EditStorageStatus
          currentStatus={currentStatus}
          currentDevice={currentDevice}
          closeModal={closeModal}
          t={t}
        />
      ),
  };
  // Инициализации статусов с сервера. принимает id устройства и тип статусов
  useEffect(() => {
    dispatch(initStatusesFromServer(currentDevice.id, 'storage'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Таблица со статусами */}
      {storageStatuses && (
        <TableMap
          data={storageStatuses}
          handleButtonClick={handleButtonClick}
          currentDevice={currentDevice}
          setActiveButton={setActiveButton}
          activeButton={activeButton}
          t={t}
        />
      )}

      {/* Блок с кнопками */}
      {!isMaster && (
        <div className="device-storage-status_button-action_container flex-wrap">
          {Object.keys(contentData)
            .slice(0, -1)
            .map((buttonName) => (
              <CustomButton
                className="device-storage-status_button-action"
                key={buttonName}
                text={buttonName}
                colorText="#FFFFF"
                onClick={() => handleButtonClick(buttonName)}
                disabled={
                  disabledBtn ||
                  ((buttonName === 'Выдать в эксплуатацию' || buttonName === t?.statusIssueOperation) &&
                    currentDevice?.broken)
                }
              />
            ))}
        </div>
      )}

      {/* Модальное окно */}
      {isOpen && (
        <Modal isOpen={isOpen} onClose={closeModal} containerSelector={'.table-for-devices_or_uipps_container'}>
          {contentData[activeModal]}
        </Modal>
      )}
    </>
  );
}

export default DeviceStorageStatus;
